export default "__VITE_ASSET__a147ab79__"